import React from 'react'
import './Loader.css'

interface Props {
    text?: string
}

const Loader: React.FC<Props> = (props) => {
    return (
        <div className="loaderContainer">
            <div className="lds-facebook">
                <div />
                <div />
                <div />
            </div>
            <p style={{ textAlign: 'center' }}>{props.text !== undefined ? props.text : 'Cariamento'}</p>
        </div>
    )
}

export default Loader
